module.exports = __webpack_public_path__ + "static/media/dc_2.b1c3cc84.jpg";